import { render, staticRenderFns } from "./FeedbackSummaryChart.vue?vue&type=template&id=4485a546&scoped=true"
import script from "./FeedbackSummaryChart.vue?vue&type=script&lang=js"
export * from "./FeedbackSummaryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485a546",
  null
  
)

export default component.exports